<template>
    <div>
        <div class="session__container" v-if="state.timer">
            <div class="session__timer">
                <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="11" cy="10.5" r="10.5" fill="#FF9B00"/>
                    <path d="M10.108 5.60001H12.052L11.764 11.42H10.42L10.108 5.60001ZM11.86 13.748C11.644 13.956 11.388 14.06 11.092 14.06C10.796 14.06 10.54 13.952 10.324 13.736C10.108 13.52 10 13.264 10 12.968C10 12.664 10.108 12.408 10.324 12.2C10.54 11.984 10.796 11.876 11.092 11.876C11.396 11.876 11.652 11.984 11.86 12.2C12.076 12.408 12.184 12.664 12.184 12.968C12.184 13.272 12.076 13.532 11.86 13.748Z" fill="black"/>
                </svg>
                <p>You have <b>{{ sessionDuration }}</b> to complete this payment</p>
            </div>
        </div>
        <div class="payment container__col-sm-12" role="main">
            <div v-if="state.isTestMode" class="testmode__info">
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.179 0.931a11.179 11.179 0 1 0 0 22.362 11.179 11.179 0 0 0 0 -22.362m2.328 17.328q-0.861 0.338 -1.378 0.518t-1.195 0.178q-1.043 0 -1.626 -0.509a1.648 1.648 0 0 1 -0.576 -1.296q0 -0.302 0.042 -0.624 0.043 -0.315 0.139 -0.718l0.72 -2.544q0.096 -0.366 0.163 -0.691a3.2 3.2 0 0 0 0.062 -0.6q0 -0.486 -0.198 -0.677 -0.205 -0.192 -0.768 -0.192a1.92 1.92 0 0 0 -0.576 0.086 8 8 0 0 0 -0.499 0.168l0.192 -0.786q0.706 -0.288 1.35 -0.494 0.648 -0.206 1.222 -0.206 1.037 0 1.602 0.504 0.562 0.499 0.562 1.301 0 0.166 -0.038 0.582 -0.035 0.419 -0.144 0.768l-0.715 2.536a8 8 0 0 0 -0.158 0.696q-0.072 0.39 -0.07 0.592 0 0.504 0.226 0.688 0.229 0.184 0.786 0.184a3.36 3.36 0 0 0 1.07 -0.253l-0.192 0.781Zm-0.128 -10.296a1.68 1.68 0 0 1 -1.206 0.466 1.728 1.728 0 0 1 -1.213 -0.466 1.488 1.488 0 0 1 -0.504 -1.128q0 -0.662 0.504 -1.136a1.728 1.728 0 0 1 1.213 -0.47q0.706 0 1.206 0.47 0.504 0.472 0.504 1.133 0 0.662 -0.504 1.128Z" fill="#F5A623"/></svg>
                <p> {{ $t("ui.testmode.banner") }} </p>
            </div>
            <div class="payment__top">
                <button :class="{ hidden: !adaptStateToDevice(), noshow: !state.hasBack }" class="back-button">
                    <svg width="7" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.467.719a.41.41 0 00.126-.3.387.387 0 00-.126-.293A.387.387 0 006.174 0a.41.41 0 00-.3.126L0 6l5.874 5.881c.084.08.184.119.3.119.117 0 .214-.04.293-.119a.41.41 0 00.126-.3.387.387 0 00-.126-.293L1.187 6 6.466.719z"
                            fill="#2D9CDB"
                        />
                    </svg>
                    <p @click="goBack">{{ translate("ui.back.btn", "Go back")}}</p>
                </button>

                <locale-switcher 
                    v-if="adaptStateToDevice()"
                    @toggle-locale="handleLocaleChange"
                />
            </div>
            <mobile-payment-header
                :customer="state.customer"
                :title="state.method.label"
                :method="currentPaymentOption"
            />
            <div class="payment-header__wrapper">
                <payment-header
                    :merchant="state.merchant"
                    :customer="state.customer"
                    :title="state.method.label"
                    :amount="currentPaymentOption === 'card' && state.dcc ? state.dcc.charge_amount : amount"
                    :currency="currentPaymentOption === 'card' && state.dcc ? state.dcc.to : currency"
                    :method="currentPaymentOption"
                />
            </div>
            <Loader />
            <payment-noop
                v-if="state.currentView == 'NOOP_VIEW' && state.processing != true"
            />
            <payment-body v-else :current-payment-option="currentPaymentOption" />
            <secured-by-flutterwave />
        </div>
    </div>
</template>
<script>
import { ref, onBeforeUnmount, onMounted, computed } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
import PaymentHeader from "@/components/layouts/payment-header";
import PaymentBody from "@/components/layouts/payment-body";
import MobilePaymentHeader from "@/components/layouts/mobile-payments/mobile-payment-header";
import SecuredByFlutterwave from "@/components/secured-by-flutterwave";
import PaymentNoop from "@/components/common/payment-noop";
import LocaleSwitcher from "@/components/locale-switcher.vue";

export default {
    name: "Payment",
    components: {
        PaymentBody,
        PaymentNoop,
        MobilePaymentHeader,
        PaymentHeader,
        SecuredByFlutterwave,
        LocaleSwitcher,
    },
    props: {
        listOfOptions: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        currentPaymentOption: {
            type: String,
            required: true,
        },
        amount: {
            type: String,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
    },
    methods: {},
    data() {
        return {};
    },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        const customDuration = ref(
            getValueFromPath(
                checkoutData.value,
                "session.session_duration",
            ) || null,
        );
        const timingDown = ref(null);

        onBeforeUnmount(() => {
            subscription();
        });
        onMounted(() => {
            customDuration.value = customDuration.value * 60;
            timingDown.value = setInterval(() => handleCountdown(), 1000);
        });
        const sessionDuration = computed(() => {
            let duration = customDuration.value;
            let hours = Math.floor(duration / 3600);
            let minutes = Math.floor((duration % 3600) / 60);
            let seconds = duration % 60;
            if (hours) {
                return hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
            }
            else return minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
        });

        function handleCountdown() {
            if (customDuration.value > 0) {
                customDuration.value--;
                return;
            }
            clearInterval(timingDown.value);
        }

        function goBack() {
            checkoutData.value.view.context.$actions.back();
        }
        function handleCloseIframe(state) {
            store.Control.close(state);
        }
        function handleLocaleChange(locale) {
            store.CurrentLocale.switch(locale);
        }
        return {
            state: mapState({
                back: (state) => getValueFromPath(state, "view.current") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                dcc: (state) => getValueFromPath(state, "dcc") || null,
                method: (state) => getValueFromPath(state, "method") || [],
                customer: (state) => getValueFromPath(state, "customer") || null,
                merchant: (state) => getValueFromPath(state, "merchant") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                hasBack: (state) => getValueFromPath(state, "view.context.hasBackAction") || false,
                isTestMode: (state) => getValueFromPath(state, "isTestMode") || false,
                timer: (state) => getValueFromPath(state, "session.session_duration") || null,
            }),
            handleCloseIframe,
            handleLocaleChange,
            goBack,
            sessionDuration,
        };
    },
    mounted() {},
};
</script>
<style lang="scss" scoped>
.payment {
  width: 100%;
  position: relative;
  @media screen and (min-width: $breakpoint-middle * 1px) {
    max-width: 390px;
    margin-left: auto;
    margin-right: 5vw;
    padding-top: 15vh;
  }
  @media screen and (min-width: $breakpoint-large * 1px) {
    margin-right: 10vw;
  }

  &-header__wrapper {
    margin: 0rem 1rem;
    @media screen and (max-width: $breakpoint-middle * 1px) {
      margin: 0;
      padding-left: 2.4rem;
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (min-width: $breakpoint-middle * 1px) {
        margin-bottom: 2.8rem;
    }
  }
}
.back-button {
  font-size: 1.3rem;
  line-height: 1.5rem;
  display: flex;
  align-items: center;
  color: $blue;
  border: none;
  background: transparent;
  p {
    margin-left: 0.741rem;
  }
}
.noshow{
    visibility: hidden;
}

.testmode__info {
    background-color: #FFF6E9;
    font-size: 14px;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
        flex: 0 1 12%;
        height: auto;
    }
}

.session__container {
    background-color: #FFF6E9;
    padding: 17px 0px;
}
.session__timer {
    width: 100%;
    font-size: 12px;
    padding: 0px 24px;
    display: flex;
    align-items: center;
    gap: 10px;

    @media screen and (min-width: $breakpoint-middle * 1px) {
        max-width: 390px;
        margin-left: auto;
        margin-right: 5vw;
        padding: 0;
    }
    @media screen and (min-width: $breakpoint-large * 1px) {
        margin-right: 10vw;
        padding: 0;
    }
}
</style>